// menucomponent/CartModal.js
import React from "react";

export default function CartModal({ cart, closeCart, removeFromCart }) {
  return (
    <div className="modal fullscreen" role="dialog" aria-modal="true">
      <div className="modal-inner">
        <button className="close-btn" onClick={closeCart}>×</button>
        <h3>Your Selection</h3>
        {cart.length === 0 ? (
          <div className="menu-empty-cart">
            <img src="https://ui-cdn.digitalocean.com/apps/ui-spaces/static/media/spaces-empty.5e1d7947c43b7e336b14e421d4a86639.svg" alt="No data available" style={{ width: "150px", marginBottom: "20px" }} />
            <h4>You have not selected any items</h4>
            <p>Looks like you have no items in your selection</p>
            <button className="menu-back-btn" onClick={closeCart}>BACK TO MENU</button>
          </div>
        ) : (
          <div className="menu-cart-items">
            {cart.map((itemObj, index) => (
              <div key={index} className="menu-cart-item">
                <span>{itemObj.item.name} - ₹{itemObj.item.price.toFixed(0)} x {itemObj.quantity}</span>
                <button
                  className="menu-remove-btn"
                  onClick={() => removeFromCart(itemObj.item, itemObj.quantity)}
                  aria-label={`Remove ${itemObj.item.name} from cart`}
                >
                  ×
                </button>
              </div>
            ))}
            <div className="menu-cart-total">Estimated Total: ₹{cart.reduce((sum, c) => sum + c.item.price * c.quantity, 0).toFixed(0)}</div>
            <button className="menu-back-btn" onClick={closeCart}>BACK TO MENU</button>
          </div>
        )}
      </div>
    </div>
  );
}
